import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

// Hook specifically for public blog posts (for BlogList component)
export const usePublicPosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load public posts only
  useEffect(() => {
    const loadPublicPosts = async () => {
      setLoading(true);
      setError(null);
      
      // Start timing for minimum loading delay
      const startTime = Date.now();
      
      try {
        const response = await fetch(`${API_BASE_URL}/api/posts`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const posts = await response.json();
        setPosts(posts || []);
      } catch (err) {
        setError(err.message);
      }
      
      // Ensure minimum loading time of 250ms for skeleton visibility
      const elapsedTime = Date.now() - startTime;
      const minLoadingTime = 250;
      const remainingTime = Math.max(0, minLoadingTime - elapsedTime);
      
      if (remainingTime > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingTime));
      }
      
      setLoading(false);
    };

    loadPublicPosts();
  }, []); // Only run once on mount

  // Get published posts only
  const getPublishedPosts = () => {
    return posts.filter(post => post.published == true);
  };

  // Get a single post by slug
  const getPostBySlug = (slug) => {
    return posts.find(post => post.slug === slug);
  };

  // Clear error
  const clearError = () => {
    setError(null);
  };

  return {
    posts,
    loading,
    error,
    getPublishedPosts,
    getPostBySlug,
    clearError
  };
};

export default usePublicPosts;